import Image, { type ImageProps } from 'next/image';
import clsx from 'clsx';

import { Container } from './Container';
import { FadeIn } from './FadeIn';
import { GridPattern } from './GridPattern';

/**
 * A section for displaying a customer testimonial with their quote and logo.
 */
export function Testimonial({
  children,
  client,
  className,
}: {
  /** The testimonial quote content. */
  children: React.ReactNode;
  /** Data about the client providing the testimonial. */
  client: { 
    /** The client's company logo. */
    logo: ImageProps['src']; 
    /** The client's company name. */
    name: string 
  };
  /** Optional CSS class name. */
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'relative isolate bg-gray-50 py-16 sm:py-28 md:py-32',
        className
      )}
    >
      <GridPattern
        className="absolute inset-0 -z-10 h-full w-full fill-gray-100 stroke-gray-950/5 [mask-image:linear-gradient(to_bottom_left,white_50%,transparent_60%)]"
        yOffset={-256}
      />
      <Container>
        <FadeIn>
          <figure className="mx-auto max-w-4xl">
            <blockquote className="relative text-3xl font-medium tracking-tight text-gray-950 sm:text-4xl">
              <p className="before:content-['“'] after:content-['”'] sm:before:absolute sm:before:right-full">
                {children}
              </p>
            </blockquote>
            <figcaption className="mt-10">
              <Image alt={client.name} src={client.logo} unoptimized />
            </figcaption>
          </figure>
        </FadeIn>
      </Container>
    </div>
  );
}
